module.exports = __webpack_public_path__ + "img/icons8-money-heist-dali.066bbe1c.svg";